<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>{{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }} Detail</h3>
      <p>
        Informasi detail mengenai
        {{ merchantTypeId == '1' ? 'merchant' : 'sub merchant' }}
      </p>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <div
        v-if="
          data != null &&
          data.aggregator_name != null &&
          data.aggregator_name != ''
        "
      >
        <v-card :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Aggregator</h3>
          </div>
        </v-card>
        <div :style="{ padding: '20px 50px 20px 50px' }">
          <v-row>
            <v-col cols="10" sm="4"> Nama Aggregator </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ data == null ? '' : data.aggregator_name }}
            </v-col>
          </v-row>
        </div>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">
            Info {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">
        <v-row>
          <v-col cols="10" sm="4"> Source Onboarding </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.source_onboarding_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Tipe
            {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{
              data == null
                ? ''
                : data.account_type == 'Corporate'
                ? 'Badan Usaha'
                : data.account_type
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Jenis QR </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.qr_type }}
          </v-col>
        </v-row>
        <v-row v-if="data != null && data.id_qr_type == 2">
          <v-col cols="10" sm="4"> Client Version </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.client_version) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Serial Number </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.sn }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nomor Rekening BNI </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.account_number }}
          </v-col>
        </v-row>
        <v-row v-if="data == null ? false : data.id_account_type == '2'">
          <v-col cols="10" sm="4"> Nama Perusahaan </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.company_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Nama {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.merchant_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nama Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.owner_name }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Nomor KTP Pemilik Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.ktp_no) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Nomor NPWP
            {{ accountType == '2' ? 'Perusahaan' : 'Pemilik Usaha' }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.npwp_no) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Email </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.email }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> No Handphone Pemilik Usaha</v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.mobile_phone) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            No Handphone
            {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}</v-col
          >
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.merchant_mobile_phone) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            No Telepon {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{
              data == null
                ? ''
                : merchantPhone == ' '
                ? '( not set )'
                : merchantPhone
            }}</v-col
          >
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Channel QR </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.channel_qr }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Model Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.merchant_model }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Jenis Usaha </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mcc_name }}
          </v-col>
        </v-row>
        <!-- Dokumen MDR Khusus -->
        <pdf-detail-api
          v-if="data?.custom_mdr_id"
          :documentId="data.custom_mdr_id"
          :filename="data.custom_mdr_filename"
          type="current"
          label="Dokumen MDR Khusus"
        />
        <v-row>
          <v-col cols="10" sm="4"> MDR On-Us </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mdr_on_us + '%' }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> MDR Off-Us </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mdr_off_us + '%' }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Kriteria {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : criteriaText(data.merchant_criteria) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4">
            Alamat {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
          </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.address }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Kota, Kecamatan, Kode Pos </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.kode_pos }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> KODE BC/KO </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.bcko) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Merchant Category Segment </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.cmer) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="4"> Referral Code </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.referral_code) }}
          </v-col>
        </v-row>
        <div
          v-if="!closeMerchantView && !blockUnblocktView"
          :style="{ 'margin-top': '8px' }"
        >
          <v-row>
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ data == null ? '' : data.approver_1 }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              {{ data == null ? '' : data.approver_2 }}
            </v-col>
          </v-row>
        </div>
        <div v-else :style="{ 'margin-top': '8px' }">
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 1 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover1"
                ref="IDApprover1"
                clearable
                v-model="IDApprover1"
                :items="itemsApprovalId1"
                return-object
                item-text="username"
                item-value="user_id"
                @change="$v.IDApprover1.$touch()"
                @blur="$v.IDApprover1.$touch()"
                @focus="onFocusApprover1"
                :error-messages="IDApprover1Errors"
                :loading="isLoadingApprovalId1"
                :search-input.sync="searchApprovalId1"
                hide-selected
              />
            </v-col>
          </v-row>
          <v-row style="align-items: center">
            <v-col cols="10" sm="4"> ID Approver 2 </v-col>
            <v-col cols="2" sm="1"> : </v-col>
            <v-col cols="12" sm="7">
              <v-autocomplete
                id="IDApprover2"
                ref="IDApprover2"
                clearable
                v-model="IDApprover2"
                :items="itemsApprovalId2"
                item-text="username"
                item-value="user_id"
                return-object
                @change="$v.IDApprover2.$touch()"
                @blur="$v.IDApprover2.$touch()"
                @focus="onFocusApprover2"
                :error-messages="IDApprover2Errors"
                :loading="isLoadingApprovalId2"
                :search-input.sync="searchApprovalId2"
                hide-selected
              />
            </v-col>
          </v-row>
        </div>

        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
          v-if="data != null && data.id_qr_type == 2"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Endpoint</h3>
          </div>
        </v-card>
        <v-row v-if="data != null && data.id_qr_type == 2">
          <v-col cols="10" sm="4"> URL </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.endpoint) }}
          </v-col>
        </v-row>
        <v-row v-if="data != null && data.id_qr_type == 2">
          <v-col cols="10" sm="4"> IP Address </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.ip_address) }}
          </v-col>
        </v-row>
        <!-- SNAP Fields -->
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4"> Callback Partner URL Token </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.access_token_endpoint) }}
          </v-col>
        </v-row>
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4"> Callback Partner ID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.cred_client_id) }}
          </v-col>
        </v-row>
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4"> Callback Partner Client Secret </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : text(data.client_secret) }}
          </v-col>
        </v-row>
        <v-row v-if="isApiSnap">
          <v-col cols="10" sm="4">Public Key Partner</v-col>
          <v-col cols="2" sm="1">:</v-col>
          <v-col cols="12" sm="7">
            <div class="public-key-container">
              <v-textarea
                :value="decryptedPublicKey"
                outlined
                disabled
                dense
                readonly
                rows="3"
                class="fixed-height-textarea"
                hide-details
              />
              <v-btn
                icon
                small
                class="copy-btn"
                @click="copyPublicKey"
                title="Copy Public Key"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Data QR</h3>
          </div>
        </v-card>
        <v-data-table
          :headers="headers"
          :items="qrList"
          :options.sync="options"
          :server-items-length="totalQrList"
          :loading="qrListLoading"
          class="elevation-1"
        >
          <template v-slot:[`item.actions`]="{}">
            <v-btn
              small
              disabled
              v-if="data != null && data.qr_type.toLowerCase() != 'qr sticker'"
            >
              <v-icon class="mr-2"> mdi-printer</v-icon>Print QR
            </v-btn>
            <a
              style="text-decoration: none"
              :download="qrFilename"
              :href="qrisFile"
              v-else
            >
              <v-btn dark small :loading="loadingDocument">
                <v-icon class="mr-2"> mdi-printer</v-icon>Print QR</v-btn
              ></a
            >
          </template>
        </v-data-table>

        <v-card
          v-if="closeMerchantView"
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Kategori Penutupan</h3>
          </div>
        </v-card>

        <div v-if="closeMerchantView">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                outlined
                id="closedMerchantCode"
                ref="closedMerchantCode"
                label="Pilih Kategori *"
                hint="Pilih kategori yang paling sesuai dengan kondisi merchant."
                persistent-hint
                clearable
                v-model="closedMerchantCode"
                :items="closedMerchantCategoryItems"
                :loading="loadingCategories"
                :filter="filterCategory"
                item-text="label"
                item-value="code"
                @change="$v.closedMerchantCode.$touch()"
                @blur="$v.closedMerchantCode.$touch()"
                :error-messages="closedMerchantCodeErrors"
              />
            </v-col>
          </v-row>
        </div>

        <v-card
          v-if="closeMerchantView"
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>
              Alasan Close
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </h3>
          </div>
        </v-card>

        <v-card
          v-if="blockUnblocktView"
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>
              Alasan Block/Unblock
              {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </h3>
          </div>
        </v-card>

        <div v-if="closeMerchantView || blockUnblocktView">
          <v-row>
            <v-col cols="12">
              <v-textarea
                outlined
                id="alasanClose"
                ref="alasanClose"
                :label="lebelView"
                v-model="alasanClose"
                @change="$v.alasanClose.$touch()"
                @blur="$v.alasanClose.$touch()"
                :error-messages="alasanCloseErrors"
              />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12">
            <v-btn
              small
              color="orange"
              dark
              :style="{ margin: '2px' }"
              @click="back"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
            <v-btn
              v-if="closeMerchantView"
              outlined
              small
              color="orange"
              :disabled="saveLoading"
              :loading="saveLoading"
              :style="{ margin: '2px' }"
              @click="saveClosemerch"
            >
              <v-icon dark left> mdi-delete </v-icon>
              Close {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
            </v-btn>

            <span v-if="this.data?.status == 'active'">
              <v-btn
                v-if="blockUnblocktView"
                small
                color="error"
                :disabled="saveLoading"
                :loading="saveLoading"
                :style="{ margin: '2px' }"
                @click="saveBlockMerch"
              >
                <v-icon dark left>mdi-close-octagon</v-icon>
                Block {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
              </v-btn>

              <v-btn
                v-if="blockUnblocktView"
                small
                color="success"
                :disabled="true"
                :style="{ margin: '2px' }"
              >
                <v-icon dark left>mdi-checkbox-marked-circle-outline</v-icon>
                Unblock
                {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
              </v-btn>
            </span>

            <span v-if="this.data?.status == 'blocked'">
              <v-btn
                v-if="blockUnblocktView"
                small
                color="error"
                :disabled="true"
                :style="{ margin: '2px' }"
              >
                <v-icon dark left>mdi-close-octagon</v-icon>
                Block {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
              </v-btn>

              <v-btn
                v-if="blockUnblocktView"
                small
                color="success"
                :disabled="saveLoading"
                :loading="saveLoading"
                :style="{ margin: '2px' }"
                @click="saveUnblockMerch"
              >
                <v-icon dark left>mdi-checkbox-marked-circle-outline</v-icon>
                Unblock
                {{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }}
              </v-btn>
            </span>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { maxLength, minLength } from 'vuelidate/lib/validators';
import {
  scrollOptions,
  dataListMerchantCriteria,
  dataUserRoles,
  dataDelayServiceHit,
} from '../../../store/params';
import { text, isEmpty, date, showAlert } from '../../../lib/helpers';
import decryptAES256GCM from '../../../lib/utils/decryptAES';

export default {
  components: {
    PdfDetailApi: () => import('../../../components/form/PdfDetailApi.vue'),
  },
  mixins: [validationMixin],
  validations: {
    // remark: { required },
    IDApprover1: {
      required() {
        return this.IDApprover1 != null && !isEmpty(this.IDApprover1.user_id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_1 == null ||
            this.errorValidation.approver_1.length < 1)
        );
      },
    },
    IDApprover2: {
      required() {
        return this.IDApprover2 != null && !isEmpty(this.IDApprover2.user_id);
      },
      isUnique() {
        return (
          this.errorValidation != null &&
          (this.errorValidation.approver_2 == null ||
            this.errorValidation.approver_2.length < 1)
        );
      },
    },

    alasanClose: {
      required(value) {
        if (this.closeMerchantView) return true;
        return !isEmpty(value);
      },
      maxLength: maxLength(50),
      minLength: minLength(5),
    },

    closedMerchantCode: {
      required(value) {
        if (!this.closeMerchantView) return true;
        return !isEmpty(value);
      },
    },
  },
  mounted() {
    this.$store.commit('master/daerah/list/clearApprovalId');
    
    this.getDetailData();
    if (this.closeMerchantView) {
      this.fetchClosedMerchantCategories();
    }
  },
  data() {
    return {
      listUserRoles: dataUserRoles,
      qrListLoading: false,
      remark: '',
      IDApprover1: { username: '', user_id: '' },
      IDApprover2: { username: '', user_id: '' },
      approver1Loaded: false,
      approver2Loaded: false,
      alasanClose: '',
      closedMerchantCode: null,
      closedMerchantCategories: [],
      loadingCategories: false,
      statusExt: '',
      options: null,
      totalQrList: 10,
      qrList: [],
      ktpFile: null,
      npwpFile: null,
      logoFile: null,
      photoFile: null,
      qrisFile: null,
      mounted: false,
      loading: false,
      saveLoading: false,
      headers: [
        {
          text: 'NMID',
          sortable: false,
          value: 'nmid',
        },
        {
          text: 'MID',
          sortable: false,
          value: 'mid',
        },
        // {
        //     text: "TID",
        //     sortable: false,
        //     value: "tid",
        // },
        {
          text: 'QR Type',
          sortable: false,
          value: 'qr_type',
        },
        {
          text: 'Status',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      search: {},
      criteriaMerchantText: dataListMerchantCriteria,
      loadingDocument: false,
      isLoadingApprovalId1: false,
      isLoadingApprovalId2: false,
      searchApprovalId1: '',
      searchApprovalId2: '',
      delayHitServiceA1: null,
      delayHitServiceA2: null,
      vewCase: null,
      vewCaseBlock: null,
    };
  },
  watch: {
    options: {
      handler() {
        if (!this.loading) {
          this.getListQR();
        }
      },
      deep: true,
    },
    searchApprovalId1: {
      handler(val) {
        if (!this.approver1Loaded) return;
        if (val != null) {
          clearTimeout(this.delayHitServiceA1);
          // if (this.namaKodepos) {
          this.delayHitServiceA1 = setTimeout(() => {
            this.getApprovalId1(this.listUserRoles[0].value, val);
          }, dataDelayServiceHit);
          // }
        }
      },
    },
    searchApprovalId2: {
      handler(val) {
        if (!this.approver2Loaded) return;
        if (val != null) {
          clearTimeout(this.delayHitServiceA2);
          // if (this.namaKodepos) {
          this.delayHitServiceA2 = setTimeout(() => {
            this.getApprovalId2(this.listUserRoles[1].value, val);
          }, dataDelayServiceHit);
          // }
        }
      },
    },
    IDApprover1: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_1?.length > 0) {
          this.$store.commit(
            'inputer/merchant/clearErrorVariable',
            'approver_1'
          );
        }
      },
      deep: true,
    },
    IDApprover2: {
      handler(val, oldVal) {
        if (val !== oldVal && this.errorValidation?.approver_2?.length > 0) {
          this.$store.commit(
            'inputer/merchant/clearErrorVariable',
            'approver_2'
          );
        }
      },
      deep: true,
    },
  },
  computed: {
    data() {
      return this.$store.state.inputer.merchant.merchant;
    },
    // loading() {
    //     return this.$store.state.inputer.merchant.loading;
    // },
    errorValidation() {
      return this.$store.state.inputer.merchant.errors;
    },
    accountType() {
      return this.data != null ? this.data.id_account_type : '1';
    },
    remarkErrors() {
      const errors = [];
      if (!this.$v.remark.$dirty) {
        return errors;
      }
      if (!this.$v.remark.required) errors.push('Remark is required.');
      return errors;
    },
    photoFilename() {
      return `Foto-Merchant-${date}-${this.$route.params.id}.jpg`;
    },
    qrFilename() {
      return `QR-Merchant-${date}-${this.$route.params.id}`;
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
    merchantPhone() {
      const area =
        this.data.phone_area_code != '' && this.data.phone_area_code != null
          ? `(${this.data.phone_area_code})`
          : '';
      const phone = this.data.phone != null ? this.data.phone : '';
      return `${area} ${phone}`;
    },
    closeMerchantView() {
      return this.$route.params.view == 'close';
    },
    isApiSnap() {
      if (this.data == null) return false;
      // eslint-disable-next-line eqeqeq
      return this.data.id_qr_type == 2 && this.data.client_version === 'SNAP';
    },
    decryptedPublicKey() {
      if (!this.isApiSnap || !this.data.public_key_inbound) return '';
      try {
        return decryptAES256GCM(this.data.public_key_inbound);
      } catch (e) {
        // If decryption fails, return original value
        return this.data.public_key_inbound;
      }
    },

    lebelView() {
      let reason = '';
      if (this.$route.params.view == 'active') {
        reason = 'Alasan close merchant (Opsional)';
        if (this.$route.params.view == 'block-unblock') {
          reason =
            'Merchant block/unblock berdasarkan permintaan dari Merchant ybs. *';
        }
      }
      return reason;
    },

    blockUnblocktView() {
      return this.$route.params.view == 'block-unblock';
    },

    alasanCloseErrors() {
      const errors = [];
      if (!this.$v.alasanClose.$dirty) return errors;
      if (!this.$v.alasanClose.required) errors.push('Alasan is required');
      if (!this.$v.alasanClose.maxLength)
        errors.push('Alasan must be less then 50 digit');
      if (!this.$v.alasanClose.minLength)
        errors.push('Alasan must be more then 5 digit');
      return errors;
    },

    closedMerchantCodeErrors() {
      const errors = [];
      if (!this.$v.closedMerchantCode.$dirty) return errors;
      if (!this.$v.closedMerchantCode.required)
        errors.push('Kategori Penutupan is required');
      return errors;
    },
    closedMerchantCategoryItems() {
      return this.closedMerchantCategories.map((category) => ({
        ...category,
        label: `${category.code} - ${category.description}`,
      }));
    },

    itemsApprovalId1() {
      const storeList = this.$store.state.master.daerah.list.approvalId1;
      
      if (storeList.length === 0 && this.data && this.data.approver_1_id) {
        return [{
          id: this.data.approver_1_id,
          username: this.data.approver_1,
          user_id: this.data.approver_1_id,
        }];
      }
      
      const list = storeList.find(
        (a) =>
          a.user_id ==
          JSON.parse(localStorage.getItem('logged_in_qram')).user.id
      );
      return list != undefined
        ? [list]
        : storeList;
    },
    itemsApprovalId2() {
      const storeList = this.$store.state.master.daerah.list.approvalId2;
      
      if (storeList.length === 0 && this.data && this.data.approver_2_id) {
        return [{
          id: this.data.approver_2_id,
          username: this.data.approver_2,
          user_id: this.data.approver_2_id,
        }];
      }
      
      return storeList;
    },
    IDApprover1Errors() {
      const errors = [];
      if (!this.$v.IDApprover1.$dirty) return errors;
      if (!this.$v.IDApprover1.required)
        errors.push('ID Approver 1 is required');
      if (!this.$v.IDApprover1.isUnique) {
        if (this.errorValidation.approver_1 != null) {
          this.errorValidation.approver_1.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    IDApprover2Errors() {
      const errors = [];
      if (!this.$v.IDApprover2.$dirty) return errors;
      if (!this.$v.IDApprover2.required)
        errors.push('ID Approver 2 is required');
      if (!this.$v.IDApprover2.isUnique) {
        if (this.errorValidation.approver_2 != null) {
          this.errorValidation.approver_2.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
    namaKodepos() {
      return this.getNamaDaerah('kodepos');
    },
  },
  methods: {
    criteriaText(value) {
      const find = this.criteriaMerchantText.find((x) => value == x.value);
      return find != undefined ? find.text : value;
    },

    async getDetailData() {
      this.loading = true;

      await this.$store
        .dispatch('inputer/merchant/viewMerchant', {
          id: this.$route.params.id,
          date,
        })
        .then(() => {
          if (this.data != null) {
            if (this.data.approver_1_id) {
              this.IDApprover1 = {
                user_id: this.data.approver_1_id,
                username: this.data.approver_1,
              };
            }
            if (this.data.approver_2_id) {
              this.IDApprover2 = {
                user_id: this.data.approver_2_id,
                username: this.data.approver_2,
              };
            }
          }
        })
        .catch(() => {
          this.$router.back();
        })
        .finally(() => {
          this.loading = false;
        });
      if ( this.data?.qr_type?.toLowerCase() === 'qr sticker' ) {
        this.loadingDocument = true;
        this.$store
          .dispatch('inputer/merchant/viewDocument', {
            id: this.$route.params.id,
            doc_type: '4',
            type: 'current',
            download: '0',
            date,
          })
          .then((response) => {
            if (response != null) {
              if (
                response.replace('data:image/jpg;base64,', '') == '' ||
              response.replace('data:image/png;base64,', '') == ''
              ) {
                this.qrisFile = null;
              } else {
                this.qrisFile = response;
              }
            }
          })
          .finally(() => {
            this.loadingDocument = false;
          });
      }
    },

    async getListQR() {
      this.qrListLoading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      await this.$store
        .dispatch('inputer/merchant/getQRList', {
          id: this.$route.params.id,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          date,
        })
        .then((response) => {
          if (response != null) {
            this.qrList = response.list;
            this.totalQrList = parseInt(response.countdata, 10);
          }
        })
        .finally(() => {
          this.qrListLoading = false;
        });
    },

    back() {
      this.$router.back();
    },

    async copyPublicKey() {
      try {
        await navigator.clipboard.writeText(this.decryptedPublicKey);
        this.$toast.success('Public Key copied to clipboard');
      } catch (err) {
        // Fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = this.decryptedPublicKey;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$toast.success('Public Key copied to clipboard');
      }
    },

    async getApprovalId1(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId1 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId1', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId1.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId1 = '';
            } else {
              this.IDApprover1 = oldApproval;
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId1 = false;
        });
    },

    async getApprovalId2(role, username = '', firstLoad = false) {
      this.isLoadingApprovalId2 = true;
      await this.$store
        .dispatch('master/daerah/list/getApprovalId2', {
          date,
          role,
          kodepos: this.namaKodepos,
          search: {
            username,
          },
        })
        .then(() => {
          if (firstLoad) {
            const oldApproval = this.itemsApprovalId2.find(
              (val) => val.username == username
            );
            if (oldApproval == undefined) {
              this.searchApprovalId2 = '';
            } else {
              this.IDApprover2 = oldApproval;
            }
          }
        })
        .finally(() => {
          this.isLoadingApprovalId2 = false;
        });
    },

    onFocusApprover1() {
      if (!this.approver1Loaded) {
        this.approver1Loaded = true;
        this.getApprovalId1(this.listUserRoles[0].value, '', false);
      }
    },

    onFocusApprover2() {
      if (!this.approver2Loaded) {
        this.approver2Loaded = true;
        this.getApprovalId2(this.listUserRoles[1].value, '', false);
      }
    },

    async fetchClosedMerchantCategories() {
      this.loadingCategories = true;
      try {
        const result = await this.$store.dispatch(
          'closedMerchantCategoryShared/getClosedMerchantCategory',
          { page: 1, limit: 100 }
        );
        this.closedMerchantCategories = result?.success ? result.data : [];
      } finally {
        this.loadingCategories = false;
      }
    },

    filterCategory(item, queryText) {
      const q = (queryText || '').toString().toLowerCase();
      const desc = (item.description || '').toString().toLowerCase();
      const code = (item.code || '').toString().toLowerCase();
      return desc.includes(q) || code.includes(q);
    },

    async saveClosemerch() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveLoading = true;

        await this.$store
          .dispatch('inputer/merchant/closeMerchant', {
            date,
            merchant_id: this.$route.params.id,
            approver_1: this.IDApprover1,
            approver_2: this.IDApprover2,
            reason: this.alasanClose,
            closed_merchant_code: this.closedMerchantCode,
          })
          .then((response) => {
            if (response) {
              showAlert(
                this.$store,
                'Close merchant submitted !',
                'mdi-check-circle',
                'green'
              );
              this.$router.push('/inputer/merchant');
            } else {
              this.scrollToErrorInput();
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.scrollToErrorInput();
      }
    },

    async saveBlockMerch() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveLoading = true;

        await this.$store
          .dispatch('inputer/merchant/blockMerchant', {
            date,
            merchant_id: this.$route.params.id,
            approver_1: this.IDApprover1,
            approver_2: this.IDApprover2,
            reason: this.alasanClose,
          })
          .then((response) => {
            if (response) {
              showAlert(
                this.$store,
                'Block merchant submitted !',
                'mdi-check-circle',
                'green'
              );
              this.$router.push('/inputer/merchant');
            } else {
              this.scrollToErrorInput();
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.scrollToErrorInput();
      }
    },

    async saveUnblockMerch() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveLoading = true;

        await this.$store
          .dispatch('inputer/merchant/unBlockMerchant', {
            date,
            merchant_id: this.$route.params.id,
            approver_1: this.IDApprover1,
            approver_2: this.IDApprover2,
            reason: this.alasanClose,
          })
          .then((response) => {
            if (response) {
              showAlert(
                this.$store,
                'Unblock merchant submitted !',
                'mdi-check-circle',
                'green'
              );
              this.$router.push('/inputer/merchant');
            } else {
              this.scrollToErrorInput();
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      } else {
        this.scrollToErrorInput();
      }
    },

    scrollToErrorInput() {
      const keys = Object.keys(this.$v);
      let isError = false;

      keys.forEach((key) => {
        const input = key;

        if (input.includes('$')) return;

        if (this.$v[input].$error) {
          this.$vuetify.goTo(`#${input}`, scrollOptions);
          isError = true;
        }
      });

      if (!isError) this.$vuetify.goTo(0);
    },

    getNamaDaerah(category) {
      if (this.data?.kode_pos != null) {
        let nama = '';
        const splitDaerah = this.data.kode_pos.split(', ');
        const [kelurahan, kecamatan, kabupaten, provinsi, kodepos] =
          splitDaerah;
        switch (category) {
          case 'kodepos':
            nama = kodepos;
            break;
          case 'provinsi':
            nama = provinsi;
            break;
          case 'kabupaten':
            nama = kabupaten;
            break;
          case 'kecamatan':
            nama = kecamatan;
            break;
          case 'kelurahan':
            nama = kelurahan;
            break;
          default:
            break;
        }
        return nama;
      }
      return '';
    },
    text,
    isEmpty,
  },
};
</script>

<style scoped>
.fixed-height-textarea ::v-deep .v-input__slot {
  max-height: 100px !important;
}

.fixed-height-textarea ::v-deep textarea {
  line-height: 1.2;
  font-family: monospace;
  overflow-y: auto !important;
}

.public-key-container {
  position: relative;
  width: 100%;
}

.copy-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  z-index: 1;
}

.copy-btn:hover {
  background-color: #e0e0e0 !important;
}
</style>
